import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/card3.webp";
import pr1 from "../images/doc1.jpeg";
import pr2 from "../images/doc2.jpeg";
import { motion } from 'framer-motion';




const GrammarCard3 = ({ post }) => {

    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Grammar Analysis - When it’s time to see your doctor
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                During my recent visit to the clinic, I mentioned to the doctor, "I have a fever and sore throat." It just hit me, you know? I came down with a cold.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                And lately, it feels like the health care quality is going down, doesn't it? Anyway, before your turn comes, it feels like forever waiting, right? In each region, it's different, I guess.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Oh, and by the way, knee, it's pronounced "niː." Gosh, my painkiller, I think it's wearing off and my knee hurts again. Could you please take a look while I’m here?
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                There's a nasty cold going around so we should all watch out!
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Let’s dive into some of the grammar in this short paragraph.
                            </Typography>

                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b><u>Grammar elements in the text:</u></b>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Present Perfect Tense:</u> <b>"I have a fever and sore throat."</b> This tense is used to describe actions or situations that have occurred in the past but have relevance to the present moment. Here, it's used to express the current condition of having a fever and sore throat.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Phrasal Verb:</u> <b>"Come down with" in "I came down with a cold."</b> This phrasal verb means to become ill, typically with a contagious illness. It's commonly used to describe the onset of sickness.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Comparative Adjective:</u> <b> <b></b>"Going down" in "the health care quality is going down." </b>This comparative adjective is used to compare the quality of healthcare in the past to its current state, indicating a decline.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Conditional Clause:</u> <b>"Before your turn comes"</b> implies a condition that must be met before something else can happen. It's used to suggest a sequence of events or actions.
                    </Typography>
                    <Grid item xs={12} lg={11} container spacing={2}>
                        <Grid item xs={6} paddingBottom={'20px'}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={6}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr2}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Adverbial Phrase:</u> <b>"In each region" </b>provides additional information about where something is happening. It indicates the location or scope of a particular action or event.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Pronunciation Guide:</u> <b>"Knee = niː </b>/ pronunciation" provides a phonetic representation of the word "knee" and explains that the 'k' is silent in its pronunciation.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Idiomatic Expression:</u> <b>"Wearing off" </b>in "I think the painkiller is wearing off." This expression means that the effects of something (in this case, a painkiller) are diminishing or becoming less effective over time.
                    </Typography>

                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <u>Phrasal Verb:</u> <b>"Going around"</b> in "There's a nasty cold going around the office." This phrasal verb means to be circulated or spread, especially regarding illnesses or rumors. It's commonly used to describe the spread of contagious diseases.
                    </Typography>

                </Container >
            </Box >
        </>
    );
};

export default GrammarCard3;
